export function calculateProductCosts(order) {
    if (!order?.products) {
        return 0;
    }
    return order.products.reduce((total, product) => {
        const productCost = product.cost_price || 0;
        return total + productCost * (product.quantity || 0);
    }, 0);
}

export function calculateNetReceived(transaction) {
    if (!transaction) {
        return 0;
    }
    return transaction.net_amount || 0;
}

export function calculateTotalPaid(order) {
    if (!order) {
        return 0;
    }
    let total = order.amount || 0;
    if (order.shipping_method && order.shipping_method.cost > 0) {
        total += order.shipping_method.cost;
    }
    if (order.discount && order.discount > 0) {
        total -= order.discount;
    }
    return total;
}

/** Commission in cents only counts when greater than zero. */
export function calculateCommission(order) {
    const commission = Number(order?.commission) || 0;
    return commission > 0 ? commission : 0;
}

export function calculateBalance(order, transaction) {
    return calculateNetReceived(transaction) - calculateProductCosts(order) - calculateCommission(order);
}

export function calculateProfitMargin(order, transaction) {
    const received = calculateNetReceived(transaction);
    const costs = calculateProductCosts(order);
    const commission = calculateCommission(order);
    if (received === 0) {
        return 0;
    }
    return ((received - costs - commission) / received) * 100;
}
